import { render, staticRenderFns } from "./VendasGuardadasModal.vue?vue&type=template&id=4d88bc83&scoped=true"
import script from "./VendasGuardadasModal.vue?vue&type=script&lang=js"
export * from "./VendasGuardadasModal.vue?vue&type=script&lang=js"
import style0 from "./VendasGuardadasModal.vue?vue&type=style&index=0&id=4d88bc83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88bc83",
  null
  
)

export default component.exports